// List with the internal news
// Update / Delete or create new ones
<!-- *********************** Login screen if the user is not logged in *********************************** -->

<template>
  <div>
    <div>
      <subpage-header back-link="dashboard" label="Maintain internal news" />
    </div>

    <message-modal />
    <div class="padding-wrapper">
      <!-- *********************** Update internal news modal pane  *********************************** -->
      <update-internal-news :update-internal-news="update_internal_news" />
      <div class="spl-maintain-news-list-modal">
        <div :class="{'spl-maintain-news-list-modal__show-reports-active': true}" class="spl-maintain-news-list-modal__show-reports">
          <div :class="{'spl-maintain-news-list-modal__show-maintain-news-overlay-open': true}" class="spl-maintain-news-list-modal__show-maintain-news-overlay">
            <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__options row">
              <!-- ****************************  Create new News   **************************** -->
              <div class="col2 spl-maintain-news-list-modal__show-maintain-news-overlay__options__create_new" @click="create_new_news()">
                Create new
              </div>

              <!-- ****************************  Divider  **************************** -->
              <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__options__divider" />

              <!-- ****************************  Header  **************************** -->
              <div class="row">
                <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__header__small_label">
                  Date
                </div>
                <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__header__small_label">
                  Title
                </div>
                <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__header__large_label">
                  Body
                </div>
              </div>

              <!-- ****************************    SAVED REPORT LIST   **************************** -->
              <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__options__scroller">
                <div
                  v-for="(newsItem, index) in news"
                  :key="'maintainInternalNews'+index"
                  class="row spl-maintain-news-list-modal__show-maintain-news-overlay__row"
                  @click="update_news(newsItem)">
                  <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__row__small_column">
                    {{ newsItem.News_Date }}
                  </div>
                  <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__row__small_column">
                    {{ newsItem.Title }}
                  </div>
                  <div class="spl-maintain-news-list-modal__show-maintain-news-overlay__row__large_column">
                    {{ newsItem.Body.substring(0,50) +"..." }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '../helpers'
import { mapState } from 'vuex'

export default {
  name: 'MaintainInternalNews',
  mixins: [Helpers],
  data () {
    return {
      update_internal_news: ''
    }
  },
  computed: {
    ...mapState('news', ['news'])
  },
  methods: {
    //* **************************** FILTER THE REPORT LIST IN THE POP UP *************************************
    create_new_news () {
      this.update_internal_news = ''
      window.bus.$emit('openNewInternalNews')
    },
    update_news (clickedNews) {
      this.update_internal_news = clickedNews
      window.bus.$emit('openUpdateInternalNews')
    }
  }
}
</script>

<style lang="scss">
    @import '../variables.scss';

    .spl-maintain-news-list-modal {
        margin-bottom: 30px;
        position: relative;

            &__show-maintain-news-overlay {
            background-color: rgba($tableRadiobuttonBorder, 0.5);
            padding: 10px 0;
            cursor: auto;
            opacity: 0;
            pointer-events: none;
            position: absolute;
            left: 0px;
            margin-top: 25px;
            top: 0;
            height: 100%x;
            margin: 0px;
            position: absolute;

            width: 100%;

            @include mobile() {
                padding: 20px $mobilePadding;
                right: 0;
                width: 100%;
            }

            &-open {
                opacity: 1;
                pointer-events: auto;
            }
            &__header {
                &__small_label {
                    color: $parcelListControlsShowColumnsOptions;
                  float: left;
                  font-size: 14px;
                  height: 15px;
                  line-height: 17px;
                  padding: 9px 12px;
                  width: 150px;
                  margin-left:10px;
                  padding-bottom:20px;
                }
                &__large_label {
                    color: $parcelListControlsShowColumnsOptions;
                  float: left;
                  font-size: 14px;
                  height: 15px;
                  line-height: 17px;
                  padding: 9px 12px;
                  width: 400px;
                  margin-left:10px;
                  padding-bottom:20px;
                }

            }
            &__row {
              cursor: pointer;
              transition: background-color $shortTransition ease-in-out;
              &:hover {
                  color: #fff;
              }
              &__small_column {
                float: left;
                font-size: 12px;
                height: 20px;
                line-height: 17px;
                padding: 9px 12px;
                width: 150px;
                margin-left:10px;
              }
              &__large_column {
                float: left;
                font-size: 12px;
                height: 20px;
                line-height: 17px;
                padding: 9px 12px;
                width: 400px;
                margin-left:10px;
              }

            }
            &__options {
                color: $tableHeaderLabel;
                font-size: 14px;
                font-weight: 600;
                padding: 10px;
                position: relative;

                @include mobile() {
                    padding-top: 25px;
                }

                &__divider {
                    background-color: rgba($parcelDetailBlockLabelColor, 0.6);
                    height: 1px;
                    margin: 10px 0 5px 0;
                }
                &__reset {
                    color: $parcelListControlsShowColumnsOptions;
                    cursor: pointer;
                    position:absolute;
                    margin-top: -10px;
                    text-transform: underline;
                    margin-right:10px;
                    right:10px;
                    transition: color $shortTransition ease-in-out;
                    &:hover {
                        color: #fff;
                    }
                }
                &__create_new {
                    color: $middleYellow;
                    cursor: pointer;
                    position:absolute;
                    margin-top: -10px;
                    text-transform: underline;
                    margin-left:0px;
                    left:10px;
                    transition: color $shortTransition ease-in-out;
                    &:hover {
                        color: #fff;
                    }
                }

                &__clear {
                    background-image: url(../assets/icon-close.svg);
                    background-position: center center;
                    background-repeat: no-repeat;
                    cursor: pointer;
                    display: inline-block;
                    height: 50px;
                    position: absolute;
                    right: 20px;
                    top: 5px;
                    width: 20px;
                }
                &__scroller {
                    height: 200px;
                    overflow-y: auto;
                    overflow-x: hidden;
                }
            }
        }
    }
</style>
